import { parseDate } from './utils'

export default class ProcessCosts {
	static fromJSON(json) {
		return new ProcessCosts(json.id)
			.withDates(
				json.budget?.creationDate,
				json.budget?.ticket?.creationDate
			)
			.withQuantity(json.quantity)
			.withAmounts(json.saleAmount, json.purchaseAmount)
			.withSurgicalRequisitionId(json.surgeryRequisitionId)
	}

	constructor(id) {
		this.id = id
		this.key = `process_cost_${id || ''}`
	}

	withDates(creationDate, reviewDate) {
		this.lastBudgetDate = creationDate ? parseDate(creationDate) : undefined
		this.reviewedAt = reviewDate ? parseDate(reviewDate) : undefined

		return this
	}

	withQuantity(quantity) {
		this.quantity = quantity
		return this
	}

	withAmounts(saleAmount, purchaseAmount) {
		this.saleAmount = saleAmount
		this.purchaseAmount = purchaseAmount

		return this
	}

	withSurgicalRequisitionId(surgeryRequisitionId) {
		this.surgeryRequisitionId = surgeryRequisitionId

		return this
	}
}
